import DataLoader from "dataloader";

//#region src/generic-dataloader/generic-dataloader.ts
var GenericDataLoader = class {
	requestFunc;
	constructor(requestFunc) {
		this.requestFunc = requestFunc;
	}
	batchLoad = async (keys) => {
		const promises = [];
		for (const key of keys) promises.push(this.requestFunc(key));
		return (await Promise.allSettled(promises)).map((result) => result.status === "fulfilled" ? result.value : result.reason);
	};
	cacheDataLoader = new DataLoader(this.batchLoad, { cacheKeyFn: (key) => typeof key === "string" ? key : JSON.stringify(key) });
};

//#endregion
export { GenericDataLoader };